<template>
  <div>
    <b-container>
      <b-row class="text-center align-middle" id="top-menu">
        <b-col cols="6" md="4" class="border-right border-left border-small-bottom">
          <div class="row">
            <div class="col-4 border-right">
              <p class="pt-2 mb-0">
                <a href="https://www.facebook.com/Veselé-Hviezdičky-106384077838043" target="_blank"
                   class="fab fa-facebook-f text-blue"></a>
              </p>
              <div class="h4">⭐</div>
            </div>
            <div class="col-4">
              <p class="pt-2 mb-0">
                <a href="https://www.facebook.com/p/DC-Vesel%C3%A1-Hviezdi%C4%8Dka-100072331494777"
                   target="_blank"
                   class="fab fa-facebook-f text-blue"></a>
              </p>
              <div class="h4">🚸</div>
            </div>
             <div class="col-4 border-left">
              <p class="pt-2 mb-0">
                <a href="https://www.instagram.com/veselahviezdicka"
                   target="_blank"
                   class="fab fa-instagram text-blue"></a>
              </p>
                <div class="h4">⭐</div>
            </div>
          </div>
        </b-col>
        <b-col cols="6" md="4"
               class="border-right border-small-bottom
               d-flex align-items-center justify-content-center">
          <p class="pt-2 mb-2 text-secondary">
            <i class="fas fa-clock"></i>
            Po-Pia: 6:00 - 17:00
          </p>
        </b-col>
        <b-col cols="6"
               class="border-right border-small-left d-flex
                align-items-center justify-content-center"
               md="4">
               <b-container>
          <b-row class="pt-2 mb-2 text-secondary text-center">
            <a href="tel:+421917514862" class="text-secondary w-100" style="font-size: 14px;">
              <i class="fas fa-phone"></i>
              0917 514 862
            </a>
          </b-row>
          <b-row class="pt-2 mb-2 text-secondary text-center">
              <a href="tel:+421915159819" class="text-secondary w-100" style="font-size: 14px;">
              <i class="fas fa-phone"></i>
              0915 159 819
            </a>
          </b-row>
               </b-container>
        </b-col>
      </b-row>
    </b-container>
    <div class="colorstrip"></div>
  </div>
</template>

<script>

export default {
  name: 'TopInfoBar',
};
</script>

<style scoped>

</style>
